module.exports = __webpack_public_path__ + "static/roid05_b-33685e47318100175d2a70c827d59875.png";